import { __assign } from "tslib";
import OptionsList from '../../internal/components/options-list';
import React, { forwardRef, useImperativeHandle, useMemo } from 'react';
import { renderOptions } from '../utils/render-options';
import { scrollUntilVisible } from '../../internal/utils/scrollable-containers';
import styles from './styles.css.js';
var PlainList = function (_a, ref) {
    var menuProps = _a.menuProps, getOptionProps = _a.getOptionProps, filteredOptions = _a.filteredOptions, filteringValue = _a.filteringValue, isKeyboard = _a.isKeyboard, checkboxes = _a.checkboxes, hasDropdownStatus = _a.hasDropdownStatus, listBottom = _a.listBottom;
    var menuRef = menuProps.ref;
    useImperativeHandle(ref, function () { return function (index) {
        var _a;
        var item = (_a = menuRef.current) === null || _a === void 0 ? void 0 : _a.querySelector("[data-mouse-target=\"" + index + "\"]");
        if (isKeyboard && item) {
            scrollUntilVisible(item);
        }
    }; }, [isKeyboard, menuRef]);
    var finalOptions = useMemo(function () {
        return renderOptions({
            options: filteredOptions,
            getOptionProps: getOptionProps,
            filteringValue: filteringValue,
            isKeyboard: isKeyboard,
            checkboxes: checkboxes,
            hasDropdownStatus: hasDropdownStatus
        });
    }, [filteredOptions, getOptionProps, filteringValue, isKeyboard, checkboxes, hasDropdownStatus]);
    return (React.createElement(OptionsList, __assign({}, menuProps),
        finalOptions,
        listBottom ? React.createElement("li", { className: styles['list-bottom'] }, listBottom) : null));
};
export default forwardRef(PlainList);
//# sourceMappingURL=plain-list.js.map